export const dateTimeFormats = {
  short: {
    year: "numeric",
    month: "short",
    day: "numeric"
  },
  long: {
    year: "numeric",
    month: "short",
    day: "numeric",
    weekday: "short",
    hour: "numeric",
    minute: "numeric",
    hour12: false
  }
};

export default {
  about_directus: "Über Directus",
  activity: "Aktivität",
  activity_log: "Aktivitäten-Log",
  activity_outside_directus:
    "Dieses Element wurde außerhalb von Directus erstellt.",
  admin_email: "Admin E-Mail",
  admin_password: "Admin Passwort",
  additional_info: "Weitergehende Infos",
  add_new: "Neu erstellen",
  add_field_filter: "Neuen Feld-Filter hinzufügen",
  add_note: "Füge eine hilfreiche Beschreibung für die Benutzer an...",
  admin_settings: "Admin Einstellungen",
  almost_done_options:
    "Fast geschaft! Bitte überprüfe unten die Feldeinstellungen.",
  almost_done_copy:
    "Jeder Feldtyp kann perfekt an deine Bedürfnisse angepasst werden. Nachfolgend die verfügbaren Optionen für das Feld, aber nur ein paar sind erforderlich.",
  all: "Alle",
  statuses: "Status",
  api_url: "API URL",
  api_installed: "API erfolgreich installiert",
  auto_generated: "Automatisch generiert...",
  batch: "Batch",
  batch_edit: "Batch-Bearbeitung",
  batch_delete: "Batch-Löschen",
  batch_delete_confirm:
    "Keine Elemente ausgewählt | Bist Du sicher, dass Du dieses Element löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden. | Bist Du sicher, dass Du diese {count} Elemente löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
  between: "Zwischen",
  both: "Beide",
  bookmarks: "Bookmarks",
  cancel: "Abbrechen",
  change_project: "Project wechseln",
  choose_one: "Bitte wählen",
  choose_project: "Project auswählen",
  choose_interface:
    "Wähle einen Feldtyp über den die Daten gepflegt werden sollen.",
  click_to_toggle_all_none: "Klicken um die ganze Spalte ein- und auszublenden",
  connection: "Verbindung",
  collection: "Kollektion",
  collections_and_fields: "Kollektionen & Felder",
  collection_updated: "Kollektion {collection} aktualisiert",
  collection_removed: "Kollektion {collection} entfernt",
  collection_names_cannot_be_changed:
    "Namen von Kollektionen können leider noch nicht bearbeitet werden.",
  collections: "Kollektionen",
  collection_count:
    "Keine Kollektionen | Eine Kollektion | {count} Kollektionen",
  "collections-directus_files": "Dateien",
  "collections-directus_users": "Benutzer",
  "collections-directus_activity": "Aktivität",
  comment: "Kommentar",
  comments: "Kommentare",
  coming_soon: "Coming soon",
  contains: "Enthält",
  config_error: "Keine App-Konfiguration vorhanden",
  config_error_copy:
    "Bitte stelle sicher, dass du die Konfigurationsdatei der App erstellt hast.",
  collection_contains_items: "{collection} enthält {count} Elemente",
  currently_selected: "Aktuelle Auswahl: {thing}",
  create: "Erstellen",
  creating_item: "Element wird erstellt",
  creating_role: "Rolle wird erstellt",
  create_role: "Rolle erstellen",
  create_field: "Feld erstellen",
  create_collection: "Kollektion erstellen",
  database_connection: "Datenbank-Verbindung",
  database_connection_copy:
    "Wie soll die Datenbankverbindung hergestellt werden, in der dieses Projekt gepflegt wird.",
  datatype: "Datentyp",
  db_user: "Datenbank-Benutzer",
  db_password: "Passwort Datenbank-Benutzer",
  db_name: "Name in der Datenbank",
  db_type: "Datenbank-Typ",
  default: "Standard",
  delete: "Löschen",
  delete_are_you_sure:
    "Soll dieses Element wirklich gelöscht werden?? Diese Aktion kann nicht rückgängig gemacht werden.",
  delete_collection_are_you_sure:
    "Soll diese Kollektion wirklich gelöscht werden?? Diese Aktion kann nicht rückgängig gemacht werden.",
  delete_field_are_you_sure:
    'Soll das Feld "{field}" wirklich gelöscht werden?? Diese Aktion kann nicht rückgängig gemacht werden.',
  delete_role_are_you_sure:
    'Soll die Rolle "{name}" wirklich gelöscht werden?? Diese Aktion kann nicht rückgängig gemacht werden.',
  delete_bookmark: "Bookmark löschen",
  delete_bookmark_body:
    "Soll das Bookmark wirklich gelöscht werden? Diese Aktion kann nicht rückgängig gemacht werden.",
  description: "Beschreibung",
  delete_confirmation: "Delete Confirmation",
  dialog_beginning: "Start des Dialogfensters.",
  discard_changes: "Änderungen verwerfen",
  display_name: "Anzeigename",
  drop_files: "Dateien hier hineinziehen...",
  dont_show: "Nicht anzeigen",
  editing: "{collection} werden bearbeitet",
  editing_item: "Element wird bearbeitet",
  editing_items: "{count} Elemente werden bearbeitet",
  editing_single: "{collection} wird bearbeitet",
  email_address: "E-Mail-Adresse",
  email: "E-Mail",
  empty_collection: "Leere Kollektion",
  empty_collection_body:
    "Bisher gibt es noch keine Elemente in dieser Kollektion",
  enable_manual_sorting: "Erlaube manuelles Sortieren",
  enter_value: "Wert eingeben",
  enter_collection_name: "Kollektionsnamen eingeben...",
  enter_role_name: "Rolennamen eingeben...",
  environment: "Umgebung",
  errors: {
    "-1": "API kann nicht erreicht werden",
    11: "Keine Datenbankverbindung",
    100: "Falscher Benutzername und/oder Passwort",
    101: "Logged out aufgrund von Inaktivität",
    102: "Logged out aufgrund von Inaktivität",
    103: "Benutzer inaktiv",
    106: "Falscher Benutzername und/oder Passwort"
  },
  error_unknown: "Unbekannter Fehler. Bitte versuche es später noch einmal",
  esc_cancel: "Escape: abbrechen und Fenster schließen",
  equal_to: "Ist gleich",
  existing: "vorhanden",
  fetching_data: "Daten werden abgerufen",
  field: "Feld",
  field_created: "Feld {field} erstellt",
  field_updated: "Feld {field} aktualisiert",
  field_removed: "Feld {field} gelöscht",
  fields: "Felder",
  fields_are_saved_automatically:
    "Feldeinstellungen werden automatisch gespeichert",
  file: "Datei",
  file_library: "Datei-Browser",
  file_upload: "Datei(en) hochladen",
  forgot_password: "Passwort vergessen",
  greater_than_equal: "Größer oder gleich",
  greater_than: "Größer als",
  help_and_docs: "Hilfe & Doku",
  keep_editing: "Weiter bearbeiten",
  hidden_detail: "In Detailansicht verstecken",
  hidden_browse: "In Listenansicht verstecken",
  host: "Host",
  in_list: "Eines von diesen",
  initial_schema: "Initiales Schema wählen",
  initial_schema_copy:
    "Wähle aus vorgegebenen Datenbank-Architekturen oder starte mit einer leeren. Dies kann später erweitert und angepasst werden.",
  interface: "Feldtyp",
  interface_count: "Kein Feldtyp | Ein Feldtyp | {count} Feldtypen",
  interfaces: "Feldtypen",
  info: "Info",
  intelligent_defaults:
    "Directus setzt automatisch passende Standardeinstellungen für die erweiterten Konfigurationseinstellungen. Diese können hier überschrieben werden.",
  interface_settings:
    "Jeder Feldtyp kann perfekt an deine Bedürfnisse angepasst werden. Nachfolgend die verfügbaren Optionen für das Feld, aber nur ein paar sind erforderlich.",
  install: "Installieren",
  install_copy:
    "Diese API wurde noch nicht konfiguriert. Möchtest Du sie jetzt installieren und konfigurieren?",
  is_empty: "Ist leer",
  is_not_null: "Ist nicht NULL",
  is_null: "Ist NULL",
  item_count: "Keine Elemente | Ein Element | {count} Elemente",
  event_count: "Keine Events | Ein Event | {count} Events",
  role_count: "Keine Rollen | Eine Rolle | {count} Rollen",
  item_count_filter:
    "Keine gefilterten Elemente | Ein gefiltertes Element | {count} gefiltertes Element",
  item_deleted: "Element gelöscht",
  item_saved: "Element gespeichert | {count} Elemente gespeicherte",
  extension_error:
    "Es ist ein Problem beim Laden der {ext} Erweiterung aufgetreten.",
  extensions_missing: "Keine Erweiterungen gefunden",
  extensions_missing_copy:
    "Bitte stelle sicher, dass du die System-Erweiterungen installiert hast.",
  latency: "Latenz",
  learn_more: "Mehr erfahren",
  leave_comment: "Kommentieren...",
  length: "Länge",
  less_than_equal: "Weniger oder gleich",
  less_than: "Weniger als",
  limited: "Beschränkt",
  loading: "Wird geladen...",
  loading_more: "Weitere Elemente werden geladen...",
  login: "Log in",
  m2m: "m:n-Beziehung (M2M)",
  m2o: "n:1-Beziehung (M2O)",
  o2m: "1:n-Beziehung (O2M)",
  name: "Name",
  name_field: "Gib diesem {field}-Feld einen Namen und konfiguriere es.",
  navigate_changes:
    "Bist Du sicher, dass Du diese Seite verlassen möchtest? Alle Änderungen gehen dabei verloren.",
  new: "Neu",
  new_file: "Neue Datei",
  no_related_entries: "Keine ähnlichen Einträge",
  not_between: "Nicht zwischen",
  not_contains: "Enthält nicht",
  note: "Notiz",
  no_results: "Keine Ergebnisse",
  no_results_body:
    "Keine Kollektions-Element bei den aktuellen Filtereinstellungen",
  no_collections: "Keine Kollektionen",
  no_collections_body: "Es wurden noch keine Kollektionen angelegt",
  no_fields: "Keine Felder",
  no_fields_body: "In dieser Kollektion wurden noch keine Felder angelegt",
  no_files: "Keine Dateien",
  no_files_body: "Es wurden noch keine Dateien hochgeladen",
  page_not_found: "Seite nicht gefunden",
  page_not_found_body:
    "Die Seite, nach der Du gesucht hast, wurde nicht gefunden.",
  permissions: "Berechtigungen",
  name_bookmark: "Möchtest Du diesen Bookmark benennen?",
  next: "Weiter",
  none: "Kein",
  not_empty: "Ist nicht leer",
  not_equal_to: "Ist nicht gleich mit",
  not_in_list: "Keines von diesen",
  manage: "Verwalten",
  dont_manage: "Nicht verwalten",
  dont_manage_copy:
    "Berechtigungen und Einstellungen der Kollektion {collection} werden endgültig vom System gelöscht! Bist Du sicher?",
  more_options: "Weitere Optionen",
  mixed: "Mixed",
  my_profile: "Mein Profil",
  other: "Andere",
  ok: "OK",
  operator: "Anwender",
  options: "Optionen",
  password: "Passwort",
  password_reset_sent:
    "Eine E-Mail zum Zurücksetzen des Passworts wurde an {email} gesendet",
  permission_states: {
    none: "Keine",
    mine: "Nur meine",
    role: "Nur für diese Rolle",
    full: "Alle",
    read: "Lesezugriff",
    create: "Schreibzugriff",
    on_create: "Auf Kollektion",
    update: "Aktualisieren",
    on_update: "Beim Aktualisieren",
    always: "Immer"
  },
  powered_by_directus: "Powered by Directus",
  preview_and_revert: "Vorschau und Zurücksetzen",
  port: "Port",
  project: "Projekt",
  project_name: "Projekt-Name",
  project_info: "Projekt-Information",
  project_info_copy:
    "Nachfolgend ein paar Fragen zu deinem Projekt, sowie die Anmeldedaten für deinen ersten Administrator.",
  read: "Lesen",
  readable_fields: "Lesbare Felder",
  readable_fields_copy: "Wähle die Felder aus, die der User sehen kann",
  readonly: "Lesezugriff",
  regex: "RegEx",
  related_entries: "Ähnliche Einträge vorhanden",
  remove: "Löschen",
  remove_related: "Ähnlichen Eintrag löschen",
  relationship: "Beziehung",
  relationship_setup:
    "Für dieses Beziehungsfeld müssen die verknüpften Felder abgebildet werden.",
  relationship_setup_copy:
    "Es gibt unterschiedliche Type relationaler Daten. Dieses Feld benutzt: {relationship}",
  related_collection: "Verknüpfte Kollektion",
  required: "Erforderlich",
  reset_preferences: "Alle Listeneinstellungen zurücksetzen",
  reset_password: "Passwort zurücksetzen",
  revert: "Zurücksetzen",
  revert_copy:
    "Möchtest Du dieses Element auf den Stand von {date} zurücksetzen?",
  roles: "Benutzerrollen",
  role_settings: "Rolleneinstellungen",
  save: "Speichern",
  save_and_add: "Speichern und neu hinzufügen",
  save_and_stay: "Speichern und Bleiben",
  save_as_copy: "Als Kopie speichern",
  save_and_explain: "Mit Erklärung speichern",
  save_and_explain_copy: "Bitte beschreibe die Änderungen",
  save_as_bookmark: "Als Bookmark speichern",
  schema: "Schema",
  search: "Suche",
  select_from_device: "Ein Gerät auswählen",
  select_existing: "Bitte auswählen",
  select_field: "Feld auswählen",
  select_fields: "Fielder auswählen",
  search_interface: "Feldtyp suchen...",
  select_interface_below: "Feldtyp auswählen",
  select_statuses: "Status auswählen",
  select_statuses_copy: "Status auswählen, die der Benutzer verwenden darf",
  settings: "Einstellungen",
  settings_interface: "Interface Einstellungen",
  settings_global: "Globale Einstellungen",
  settings_collections_fields: "Kollektionen & Felder",
  settings_permissions: "Rollen & Berechtigungen",
  settings_extensions: "Erweiterungen",
  server_details: "Server Details",
  server_error: "Server Fehler",
  server_error_copy:
    "Es ist ein Problem mit dem Server oder der Datenbank aufgetreten.",
  server_trouble: "Server-Problem",
  server_trouble_copy:
    "Versuche es später noch einmal oder kontaktiere den Systemadministrator.",
  show_advanced_options: "Erweiterte Optionen anzeigen",
  show_directus_collections: "Directus System-Kollektionen anzeigen",
  something_went_wrong: "Irgendwas ist schief gelaufen...",
  something_went_wrong_body:
    "Wir haben ein Problem bei der Verarbeitung deiner Anfrage... Bitte versuche es noch mal durch Neuladen dieser Seite. Wenn das Problem weiterhin besteht, kontaktiere bitte deinen Systemadministrator.",
  sign_in: "Login",
  signing_in: "Einloggen",
  sign_out: "Ausloggen",
  sign_out_confirm: "Bist Du sicher, dass Du Dich ausloggen möchtest?",
  sign_out_confirm_edits:
    "Bist Du sicher, dass Du Dich ausloggen möchtest? Alle ungespeicherten Änderungen gehen dabei verloren.",
  to: "An",
  this_collection: "Diese Kollektion",
  unsaved_changes_copy:
    "Es gibt ungespeicherte Änderungen! Bist Du sicher, dass Du diese Seite verlassen möchtest?",
  user_directory: "Benutzerverzeichnis",
  update: "Update",
  update_confirm:
    "Bist Du sicher, dass Du {count} Elemente aktualisieren möchtest?",
  unique: "Unique",
  user_edit_warning:
    "{first_name} {last_name} bearbeitet dieses Element ebenfalls. Bitte sprecht Euch ab, damit deine Änderungen nicht verloren gehen.",
  value: "Wert",
  values: "Werte",
  validation: "Validierung",
  version: "Version",
  version_and_updates: "Version und Updates",
  view_type: "Ansehen als...",
  writable_fields: "Beschreibbare Felder",
  write_fields_copy: "Wähle die Felder aus, die der User bearbeiten darf.",
  yes: "Ja",
  duplicating_field: "Feld duplizieren",
  duplicate: "Duplikat"
};
